import _ from "lodash";
import {formMessageActionTypes} from "./formMessageActions";

const initialState = {
    formMessage: [],
    formMessageHeader: "",
    formWarningNotification: false,
    formErrorNotification: false,
    formSuccessNotification: false,
}

const formMessageReducer = (state = initialState, action) => {
    switch (action.type) {

        case formMessageActionTypes.DISPLAY_WARNING_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.formMessage = action.payload.message;
            newState.formWarningNotification = action.payload.warning;
            newState.formMessageHeader = action.payload.header ? action.payload.header : "MISSING FIELDS: ";
            return newState;
        }

        case formMessageActionTypes.DISPLAY_ERROR_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.formMessage = action.payload.message;
            newState.formErrorNotification = action.payload.error;
            newState.formMessageHeader = "ERROR: "
            return newState;
        }

        case formMessageActionTypes.DISPLAY_DUPLICATE_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.formMessage = action.payload.message;
            newState.formErrorNotification = action.payload.duplicate;
            newState.formMessageHeader = "DUPLICATE EXISTS: "
            return newState;
        }

        case formMessageActionTypes.DISPLAY_SUCCESS_MESSAGE: {
            let newState = _.cloneDeep(state);
            newState.formMessage = action.payload.message;
            newState.formSuccessNotification = action.payload.success;
            newState.formMessageHeader = "SUCCESS: "
            return newState;

        }

        case formMessageActionTypes.CLEAR_ERROR_MESSAGE: {
            return initialState;
        }

        default:
            return state;
    }
}

export default formMessageReducer;
